import kamala from '../../kamala'
import Layout from './Layout'
import Header from './Header'
import Aside from './Aside'
import Main from './Main'
import Footer from './Footer'

const KLayoutFamily = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Layout.name, Layout)
    Vue.component(Header.name, Header)
    Vue.component(Aside.name, Aside)
    Vue.component(Main.name, Main)
    Vue.component(Footer.name, Footer)
  },
  KLayout: Layout,
  KHeader: Header,
  KAside: Aside,
  KMain: Main,
  KFooter: Footer,
}

export {
  Layout,
  Header,
  Aside,
  Main,
  Footer,
}

export default KLayoutFamily
